import { Component, Input } from "@angular/core"
import { Router } from "@angular/router"
import NavigationNode from "../../../models/navigationNode.model"

@Component({
    selector: "app-side-navigation-mobile",
    templateUrl: "./side-navigation-mobile.component.html",
    styleUrls: ["./side-navigation-mobile.component.scss"],
})
export class SideNavigationMobileComponent {
    @Input() public navigationNodes: NavigationNode[]
    @Input() public activeNode: NavigationNode

    public secondLevelNodes: NavigationNode[]

    constructor(private router: Router) {}

    public ngOnInit() {
        this.secondLevelNodes = this.getLevelTwoNodes()
    }

    public ngOnChanges() {
        this.secondLevelNodes = this.getLevelTwoNodes()
    }

    public selectNode(node) {
        this.router.navigate([node.getRouterLink()])
        this.secondLevelNodes = this.getLevelTwoNodes()
    }

    public getParentNode() {
        if (this.navigationNodes[0].parents.length === 0) {
            return this.navigationNodes[0]
        } else {
            return this.navigationNodes[0].parents[0]
        }
    }

    public getLevelTwoNodes() {
        return this.getParentNode().children.filter((item) => {
            return item !== this.activeNode
        })
    }
}
